export class NextConfig {
    public static config = {
        FileNumber: 10,
    };
}